import { GlobalStorage } from "./storage";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type StorageWrapperFunc = () => Storage;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type StorageWrapper = GlobalStorage;

/**
 *
 */
export type SetKeyTtlOptions = {
  /*                                           */
  ms?: number;
  /*                                      */
  s?: number;
  /*                                      */
  m?: number;
  /*                                    */
  h?: number;
  /*                                   */
  d?: number;
  /*                                    */
  y?: number;
};

export interface SetKeyOptions {
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  ttl?: SetKeyTtlOptions | Date | number | `${number}${keyof SetKeyTtlOptions}`;
}

/**
 *
 */
export interface StorageOptions extends SetKeyOptions {}


/**
 *
 *
 *
 *
 *
 *
 *
 */
export function storage(
  storageObjectOrFunction: Storage | StorageWrapperFunc,
  options?: StorageOptions,
): GlobalStorage {
  return new GlobalStorage(storageObjectOrFunction, options);
}
